import { useQuery } from 'react-query';

import ApplicationService from '../../../../services/applicationService';

export const useApplicantDeniedReason = ({ applicantId, isCanceled }) => {
  const queryKey = [`applicantDeniedReason-${applicantId}`];
  const applicationService = new ApplicationService();
  const { data, isLoading } = useQuery(
    queryKey,
    () => applicationService.getApplicantDeniedReason({ applicantId }),
    {
      enabled: !!applicantId && isCanceled,
      refetchOnWindowFocus: true,
    },
  );

  return { deniedReasonId: data?.cancelReasonId ?? null, isLoading };
};
